import { defaultTo, join, map, pipe, propOr } from 'ramda';

export const getAuthors = pipe(
    defaultTo({}),
    propOr([], 'authors'),
    element => (Array.isArray(element) ? element : []),
    map(i => `${i.name ? i.name : ''}${i.name && i.surname ? ' ' : ''}${i.surname ? i.surname : ''}`),
    join(', ')
);
